import { css } from 'emotion';

import { colors, getRGBA } from '@cobliteam/base-components/src/styles';

import GeofenceTypeItems from '../../../GeofenceTypeItems';

const icon = css`
  width: 16px;
  height: 16px;
  padding: 8px;
  box-sizing: content-box;
  border-radius: 3px;
  flex-shrink: 0;
`;

const iconDefault = css`
  ${icon}
  background-color: ${getRGBA(colors.gray.dark, 0.1)};
  color: ${colors.gray.dark};
`;

const iconClient = css`
  svg {
    ${icon}
    background-color: ${getRGBA(GeofenceTypeItems.CLIENT.activeColor, 0.1)};
    color: ${GeofenceTypeItems.CLIENT.activeColor};
  }
`;

const iconBase = css`
  svg {
    ${icon}
    background-color: ${getRGBA(GeofenceTypeItems.BASE.activeColor, 0.1)};
    color: ${GeofenceTypeItems.BASE.activeColor};
  }
`;

const iconOther = css`
  svg {
    ${icon}
    background-color: ${getRGBA(GeofenceTypeItems.OTHER.activeColor, 0.1)};
    color: ${GeofenceTypeItems.OTHER.activeColor};
  }
`;

const iconSupply = css`
  svg {
    ${icon}
    background-color: ${getRGBA(GeofenceTypeItems.SUPPLY.activeColor, 0.1)};
    color: ${GeofenceTypeItems.SUPPLY.activeColor};
  }
`;

const iconMaintenance = css`
  svg {
    ${icon}
    background-color: ${getRGBA(GeofenceTypeItems.MAINTENANCE.activeColor, 0.1)};
    color: ${GeofenceTypeItems.MAINTENANCE.activeColor};
  }
`;

const iconHeadquarter = css`
  svg {
    ${icon}
    background-color: ${getRGBA(GeofenceTypeItems.HEADQUARTER.activeColor, 0.1)};
    color: ${GeofenceTypeItems.HEADQUARTER.activeColor};
  }
`;

export default {
  iconDefault,
  iconClient,
  iconBase,
  iconOther,
  iconSupply,
  iconMaintenance,
  iconHeadquarter,
};
